import { doc, DocumentReference, DocumentSnapshot } from 'firebase/firestore';
import { db } from '../constants/firebaseModular';
import { Product } from '@usacsmideo/types';
import { useFirestoreListener } from './useFirestoreListener';

function useProducts() {
  return useFirestoreListener<DocumentReference, Product[]>({
    target: doc(db, 'config', 'products'),
    queryKey: ['products'],
    label: 'products',
    transform: (snapshot: DocumentSnapshot) => {
      if (!snapshot.exists()) {
        return undefined;
      }
      const dataObj = snapshot.data()!;
      const dataArray: Product[] = [];
      Object.keys(dataObj).forEach((key: string) => dataArray.push(dataObj[key]));
      return dataArray;
    },
  });
}

export default useProducts;
